var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.53 19.47L16.982 15.922C18.086 14.583 18.75 12.868 18.75 11C18.75 6.727 15.273 3.25 11 3.25C6.727 3.25 3.25 6.727 3.25 11C3.25 15.273 6.727 18.75 11 18.75C12.867 18.75 14.582 18.086 15.922 16.982L19.47 20.53C19.616 20.676 19.808 20.75 20 20.75C20.192 20.75 20.384 20.677 20.53 20.53C20.823 20.237 20.823 19.763 20.53 19.47ZM4.75 11C4.75 7.554 7.554 4.75 11 4.75C14.446 4.75 17.25 7.554 17.25 11C17.25 14.446 14.446 17.25 11 17.25C7.554 17.25 4.75 14.446 4.75 11Z",
    fill: "#5A5976"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDesk);
export default __webpack_public_path__ + "static/media/search-desk.a7d6cb32e75cf010f01e4c227b1013fc.svg";
export { ForwardRef as ReactComponent };